import { Step } from "../../../hooks/useSignup"

type RegisterTitleProps = {
  currentStep: Step
  companyName: string | undefined
  companyNameStatus:
    | "AUTOMATIC"
    | "CUSTOM"
    | "CUSTOM_CONFIRMED"
    | "AUTOMATIC_CONFIRMED"
    | undefined
  formValidation: boolean | undefined
}
function RegisterTitle({
  companyName,
  companyNameStatus,
  currentStep,
  formValidation,
}: RegisterTitleProps) {
  return (
    <div className="flex flex-col gap-y-1 text-2xl font-bold md:text-3xl">
      {(currentStep === Step.InputCustomCompanyName ||
        companyNameStatus === "CUSTOM") &&
      currentStep <= Step.InputCustomCompanyName ? (
        <>
          <p>가입 사업자 파악을 위해</p>
          <p>사업자명을 적어주세요</p>
        </>
      ) : currentStep <= Step.ConfirmCompanyInfo || !companyName ? (
        <>
          <p>30초 만에 회원가입하고</p>
          <p>최저가 택배를 이용하세요</p>
        </>
      ) : currentStep < Step.InputPhoneNumberVerificationKey ? (
        <>
          <p>
            {companyName}
            <span className="font-normal">님,</span>
          </p>
          <p>함께해서 반가워요!</p>
        </>
      ) : currentStep === Step.InputPhoneNumberVerificationKey ? (
        <>
          <p>
            카카오톡 <span className="font-normal">또는</span> SMS
            <span className="font-normal">에서</span>
          </p>
          <p>인증코드를 확인해주세요.</p>
        </>
      ) : currentStep === Step.InputPassword ? (
        <>
          <p>
            {companyName}
            <span className="font-normal">님,</span>
          </p>
          <p>비밀번호를 설정해주세요.</p>
        </>
      ) : !formValidation ? (
        <>
          <p>
            {companyName}
            <span className="font-normal">님,</span>
          </p>
          <p>거의 다 됐어요!</p>
        </>
      ) : (
        <>
          <p>
            {companyName}
            <span className="font-normal">님,</span>
          </p>
          <p>
            회원가입 버튼
            <span className="font-normal">을 눌러주세요!</span>
          </p>
        </>
      )}
    </div>
  )
}

export default RegisterTitle
